import api from "../apiConfig";

const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      const val = p[key];
      if (val !== null && val !== undefined && val !== "") {
        const resolved =
          typeof val === "object" && val !== null && "id" in val ? val.id : val;
        if (resolved !== null && resolved !== undefined && resolved !== "") {
          params.append(key, resolved);
        }
      }
    });
  }
  return params;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  taskIndex(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/qc/task-index?${p}`);
  },
  taskIndexPost(data) {
    return api.post(`/api/v1/qc/task-index`, data);
  },
  getDashboard(params = null) {
    const p = paramsFactory(params);
    const queryString = p.toString() ? `?${p.toString()}` : "";
    return api.get(`/api/v1/qc/dashboard${queryString}`).catch((err) => {
      if (err?.response?.status === 404) {
        return api.get(`/qc/dashboard${queryString}`);
      }
      throw err;
    });
  },
  getTaskById(id) {
    return api.get(`/api/v1/qc/task/${id}`).catch((err) => {
      if (err?.response?.status === 404) {
        return api.get(`/qc/task/${id}`);
      }
      throw err;
    });
  },
  getEvaluationStatusList() {
    return api
      .get(`/api/v1/qa-maintenance/evaluation-status-list`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          return api.get(`/qa-maintenance/evaluation-status-list`);
        }
        throw err;
      });
  },
  getReopenReasons() {
    return api
      .get(`/api/v1/qa-maintenance/re-open-reasons`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          return api.get(`/qa-maintenance/re-open-reasons`);
        }
        throw err;
      });
  },
  evaluate(data) {
    if (data.id) {
      return api.put(`/api/v1/qa-maintenance/${data.id}`, data);
    }
    return api.post(`/api/v1/qa-maintenance`, data);
  },
};

